import { DateTime } from 'luxon';
import * as React from 'react';
import { Container } from 'types/Watchlist';
import {
  DATE_FORMATS,
  formatMotherVessel,
  formatPortOfLoading,
  formatTerminalOfLoading,
} from 'utils/container-transforms';
import { Row, RowGroup } from '../components';

interface Props {
  container: Container;
}

const formatDate = (date: string | null | undefined) => {
  return date ? DateTime.fromISO(date).toFormat(DATE_FORMATS.SINGLE_DATE_FORMAT) : null;
};

export const Origin: React.FC<Props> = (props) => {
  const { container } = props;

  const estimatedDeparture = formatDate(container?.shipment?.departureDate?.estimated);
  const estimatedArrival = formatDate(container.vesselArrival?.estimated);
  const actualArrival = formatDate(container.vesselArrival?.actual);

  return (
    <RowGroup label="Origin">
      <Row label="Shipping line">{container.shipment?.shippingLine.name}</Row>
      <Row label="Port of loading">{formatPortOfLoading(container)?.value}</Row>
      <Row label="Terminal of loading">{formatTerminalOfLoading(container)?.value}</Row>
      <Row label="Estimated time of departure (ETD)">{estimatedDeparture}</Row>
      <Row label="Mother vessel">{formatMotherVessel(container)?.value}</Row>
      <Row label="Vessel estimated time of arrival (ETA)">{estimatedArrival}</Row>
      <Row label="Vessel actual time of arrival (ATA)">{actualArrival}</Row>
    </RowGroup>
  );
};
Origin.displayName = 'Shipments.DetailDrawer.Summary.Origin';
